<template>
    <v-container class="pa-5" fluid>
        <CreateAccidentDialog
            :accident="accident"
            :is-open="createAccidentDialog"
            :user-production-sub-department-id="userProductionSubDepartmentId"
            :can-update-accident-departments-fields="canUpdateAccidentDepartmentsFields"
            @create-accident="createAccident"
            @close-accident-dialog="closeCreateAccidentDialog"
        />

        <StatusHistoryDialog
            :accident-status-history="accidentStatusHistory"
            :is-open="statusHistoryDialog"
            @close-status-history-dialog="closeStatusHistoryDialog"
        />

        <ConfirmDialog
            :is-open="confirmAssignUserDialog"
            :data="accident"
            :action-loading="actionLoading.assignUser"
            @on-confirm="assignCurrentUser"
            @on-abort="closeConfirmAssignUserDialog"
        >
            <template #title>
                Przypisanie awarii #{{ accident.id }}
            </template>
            <template #content>
                Czy na pewno chcesz przypisać awarię do siebie?
            </template>
            <template #confirmButton>
                Potwierdź
            </template>
        </ConfirmDialog>

        <ConfirmDialog
            :is-open="confirmDeleteAccidentDialog"
            :data="accident"
            :action-loading="actionLoading.deleteAccident"
            @on-confirm="deleteAccident"
            @on-abort="closeConfirmDeleteAccidentDialog"
        >
            <template #title>
                Usuwanie awarii #{{ accident.id }}
            </template>
            <template #content>
                Czy na pewno usunąć nierozwiązaną awarię?
            </template>
            <template #confirmButton>
                Potwierdź
            </template>
        </ConfirmDialog>

        <page-title>Lista awarii</page-title>

        <v-row align="center">
            <v-col cols="12" sm="4" lg="4">
                <v-btn
                    color="secondary"
                    medium
                    data-sentry-label="Przypisz do mnie"
                    @click="showCreateAccidentDialog"
                >
                    <v-icon left>
                        mdi-plus
                    </v-icon>
                    Zgłoś awarię
                </v-btn>
            </v-col>
            <v-col cols="12" sm="8" lg="8">
                <v-container fluid class="pa-0">
                    <v-row justify="end" dense>
                        <v-col v-if="isAdminUser" sm="auto">
                            <v-checkbox
                                v-model="filters.adminAccepted"
                                label="Pokaż niezatwierdzone"
                                hide-details
                                class="mt-2"
                                @change="changeFilter"
                            />
                        </v-col>
                        <v-col sm="auto">
                            <v-checkbox
                                v-model="filters.isSolved"
                                label="Ukryj rozwiązane"
                                hide-details
                                class="mt-2"
                                @change="changeFilter"
                            />
                        </v-col>
                        <v-col sm="auto">
                            <v-checkbox
                                v-model="filters.lastAssignee"
                                label="Pokaż moje"
                                hide-details
                                class="mt-2"
                                @change="changeFilter"
                            />
                        </v-col>
                        <v-col cols="auto">
                            <v-menu
                                v-model="filtersMenu"
                                top
                                left
                                transition="scroll-x-reverse-transition"
                                :close-on-content-click="false"
                            >
                                <template #activator="{on}">
                                    <v-btn
                                        fab
                                        :color="hasFilters ? 'secondary' : 'grey darken-1'"
                                        elevation="1"
                                        small
                                        v-on="on"
                                    >
                                        <v-icon v-if="hasFilters" color="white">
                                            mdi-filter-plus
                                        </v-icon>
                                        <v-icon v-else color="white">
                                            mdi-filter-minus
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <v-card>
                                    <v-container fluid>
                                        <v-row justify="end" dense>
                                            <v-col cols="auto">
                                                <v-btn
                                                    icon
                                                    small
                                                    @click="toggleFiltersMenu()"
                                                >
                                                    <v-icon color="grey darken-2">
                                                        mdi-close
                                                    </v-icon>
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" md="6" lg="3">
                                                <v-select
                                                    v-model="filters.machine"
                                                    :items="machines"
                                                    item-value="id"
                                                    placeholder="Maszyna"
                                                    no-data-text="Brak danych..."
                                                    clearable
                                                    hide-details
                                                    single-line
                                                    solo
                                                    @change="changeFilter"
                                                >
                                                    <template slot="selection" slot-scope="data">
                                                        {{ data.item.name }}
                                                    </template>

                                                    <template slot="item" slot-scope="data">
                                                        {{ data.item.name }}
                                                    </template>
                                                </v-select>
                                            </v-col>
                                            <v-col cols="12" md="6" lg="3">
                                                <v-select
                                                    v-model="filters.machine__productionDepartment_id"
                                                    :items="productionDepartments"
                                                    item-value="id"
                                                    placeholder="Dział produkcyjny"
                                                    no-data-text="Brak danych..."
                                                    clearable
                                                    hide-details
                                                    single-line
                                                    solo
                                                    @change="changeFilter"
                                                >
                                                    <template slot="selection" slot-scope="data">
                                                        {{ data.item.name }}
                                                    </template>

                                                    <template slot="item" slot-scope="data">
                                                        {{ data.item.name }}
                                                    </template>
                                                </v-select>
                                            </v-col>
                                            <v-col cols="12" md="6" lg="3">
                                                <v-select
                                                    v-model="filters.accidentStatus"
                                                    :items="accidentStatuses"
                                                    item-value="id"
                                                    placeholder="Status"
                                                    no-data-text="Brak danych..."
                                                    clearable
                                                    hide-details
                                                    solo
                                                    @change="changeFilter"
                                                >
                                                    <template slot="selection" slot-scope="data">
                                                        {{ data.item.name }}
                                                    </template>

                                                    <template slot="item" slot-scope="data">
                                                        {{ data.item.name }}
                                                    </template>
                                                </v-select>
                                            </v-col>
                                            <v-col cols="12" md="4" lg="2">
                                                <v-select
                                                    v-model="filters.accidentDepartment"
                                                    :items="accidentUserDepartments"
                                                    item-value="id"
                                                    placeholder="Dział awarii"
                                                    no-data-text="Brak danych..."
                                                    clearable
                                                    hide-details
                                                    solo
                                                    @change="changeFilter"
                                                >
                                                    <template slot="selection" slot-scope="data">
                                                        {{ data.item.name }}
                                                    </template>

                                                    <template slot="item" slot-scope="data">
                                                        {{ data.item.name }}
                                                    </template>
                                                </v-select>
                                            </v-col>
                                            <v-col cols="12" sm="6" lg="4">
                                                <v-autocomplete
                                                    v-model="filters.lastAssignee"
                                                    label="Osoba ostatnio przypisana"
                                                    :items="users"
                                                    :filter="customUsersFilter"
                                                    :loading="usersSearchLoading"
                                                    :search-input.sync="usersSearch"
                                                    class="v-text-field--placeholder-dark"
                                                    hide-details
                                                    solo
                                                    item-value="id"
                                                    no-data-text="Nie znaleziono"
                                                    clearable
                                                    @change="changeFilter"
                                                >
                                                    <template slot="no-data">
                                                        <v-list-item>
                                                            <v-list-item-title>
                                                                <template v-if="!usersSearch">
                                                                    Wpisz treść aby odnaleźć <strong>użytkownika</strong>.
                                                                </template>
                                                                <template v-else-if="usersSearchLoading">
                                                                    Trwa wyszukiwanie...
                                                                </template>
                                                                <template v-else>
                                                                    Nie znaleziono
                                                                </template>
                                                            </v-list-item-title>
                                                        </v-list-item>
                                                    </template>
                                                    <template slot="selection" slot-scope="data">
                                                        <template v-if="data.item.firstName && data.item.lastName">
                                                            {{ data.item.firstName }} {{ data.item.lastName }}
                                                        </template>
                                                        <template v-else>
                                                            {{ data.item.username }}
                                                        </template>
                                                    </template>
                                                    <template slot="item" slot-scope="data">
                                                        <template v-if="data.item.firstName && data.item.lastName">
                                                            {{ data.item.firstName }} {{ data.item.lastName }}
                                                        </template>
                                                        <template v-else>
                                                            {{ data.item.username }}
                                                        </template>
                                                    </template>
                                                </v-autocomplete>
                                            </v-col>
                                            <v-col cols="12" md="4" lg="3">
                                                <v-menu
                                                    v-model="menuFrom"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px"
                                                >
                                                    <template #activator="{on}">
                                                        <v-text-field
                                                            v-model="filters.createdAt__gte"
                                                            label="Data utworzenia od:"
                                                            prepend-icon="mdi-calendar"
                                                            readonly
                                                            clearable
                                                            solo
                                                            hide-details
                                                            v-on="on"
                                                            @input="changeFilter"
                                                            @click:clear="clearFilter('createdAt__gte')"
                                                        />
                                                    </template>
                                                    <v-date-picker
                                                        v-model="filters.createdAt__gte"
                                                        first-day-of-week="1"
                                                        @change="changeFilter"
                                                        @input="menuFrom = false"
                                                    />
                                                </v-menu>
                                            </v-col>
                                            <v-col cols="12" md="4" lg="3">
                                                <v-menu
                                                    v-model="menuTo"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px"
                                                >
                                                    <template #activator="{on}">
                                                        <v-text-field
                                                            v-model="filters.createdAt__lte"
                                                            label="Data utworzenia do:"
                                                            prepend-icon="mdi-calendar"
                                                            readonly
                                                            clearable
                                                            solo
                                                            hide-details
                                                            v-on="on"
                                                            @input="changeFilter"
                                                            @click:clear="clearFilter('createdAt__lte')"
                                                        />
                                                    </template>
                                                    <v-date-picker
                                                        v-model="filters.createdAt__lte"
                                                        first-day-of-week="1"
                                                        @change="changeFilter"
                                                        @input="menuTo = false"
                                                    />
                                                </v-menu>
                                            </v-col>
                                            <v-col cols="12" md="4" lg="2">
                                                <v-autocomplete
                                                    v-model="filters.accidentType"
                                                    label="Typ"
                                                    :items="accidentTypes"
                                                    :search-input.sync="searchType"
                                                    item-value="id"
                                                    item-text="name"
                                                    no-data-text="Nie znaleziono typu"
                                                    clearable
                                                    hide-details
                                                    solo
                                                    @change="changeFilter"
                                                />
                                            </v-col>
                                            <v-col cols="12" md="4" lg="3">
                                                <v-menu
                                                    v-model="menuFromSolvedAtGte"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px"
                                                >
                                                    <template #activator="{on}">
                                                        <v-text-field
                                                            v-model="filters.solvedAt__gte"
                                                            label="Data usunięcia od:"
                                                            prepend-icon="mdi-calendar"
                                                            readonly
                                                            clearable
                                                            solo
                                                            hide-details
                                                            v-on="on"
                                                            @input="changeFilter"
                                                            @click:clear="clearFilter('solvedAt__gte')"
                                                        />
                                                    </template>
                                                    <v-date-picker
                                                        v-model="filters.solvedAt__gte"
                                                        first-day-of-week="1"
                                                        @change="changeFilter"
                                                        @input="menuFromSolvedAt = false"
                                                    />
                                                </v-menu>
                                            </v-col>
                                            <v-col cols="12" md="4" lg="3">
                                                <v-menu
                                                    v-model="menuFromSolvedAtLte"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px"
                                                >
                                                    <template #activator="{on}">
                                                        <v-text-field
                                                            v-model="filters.solvedAt__lte"
                                                            label="Data usunięcia do:"
                                                            prepend-icon="mdi-calendar"
                                                            readonly
                                                            clearable
                                                            solo
                                                            hide-details
                                                            v-on="on"
                                                            @input="changeFilter"
                                                            @click:clear="clearFilter('solvedAt__lte')"
                                                        />
                                                    </template>
                                                    <v-date-picker
                                                        v-model="filters.solvedAt__lte"
                                                        first-day-of-week="1"
                                                        @change="changeFilter"
                                                        @input="menuFromSolvedAtLte = false"
                                                    />
                                                </v-menu>
                                            </v-col>
                                            <v-col cols="12" md="5" lg="5">
                                                <v-autocomplete
                                                    v-model="filters.costCenterNumber__number"
                                                    label="MPK"
                                                    :items="costCenterNumbers"
                                                    :search-input.sync="searchCostCenterNumber"
                                                    item-value="number"
                                                    item-text="verboseName"
                                                    no-data-text="Nie znaleziono MPK"
                                                    clearable
                                                    hide-details
                                                    solo
                                                    @change="changeFilter"
                                                />
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
        <v-row justify="end" no-gutters>
            <v-col cols="auto">
                <v-btn
                    v-if="canGenerateAccidentsReport"
                    text
                    x-small
                    data-sentry-label="Generuj raport"
                    :disabled="generateAccidentsReportLoading"
                    @click="generateAccidentsReport"
                >
                    <v-icon
                        v-if="!generateAccidentsReportLoading"
                        small
                        color="green"
                    >
                        mdi-file-excel
                    </v-icon>
                    <v-progress-circular
                        v-else
                        indeterminate
                        color="primary"
                        class="mr-1"
                        size="12"
                        width="2"
                    />
                    Generuj raport
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        :headers="accidentHeaders"
                        :items="accidents"
                        :loading="accidentsLoading"
                        :footer-props="footerProps"
                        :server-items-length="pagination.itemsLength"
                        :page.sync="pagination.page"
                        :items-per-page.sync="pagination.itemsPerPage"
                        :mobile-breakpoint="0"
                        name="accidentsData"
                        @pagination="updatePagination"
                    >
                        <template #item="{item}">
                            <tr :class="{'isSelected': selectedAccidentId == item.id}">
                                <td :class="accidentLabelClass(item.accidentStatusId)">
                                    <v-tooltip v-if="!isLoggedUserAssigned(item.lastAssignee) && !hasStatusDeleted(item.accidentStatusId) && item.adminAccepted" :open-delay="tooltipDelay" top>
                                        <template #activator="{on}">
                                            <v-btn
                                                icon
                                                data-sentry-label="Przypisz do mnie"
                                                v-on="on"
                                                @click="showConfirmAssignUserDialog(item)"
                                            >
                                                <v-icon
                                                    color="blue"
                                                >
                                                    mdi-account-check
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Przypisz do mnie</span>
                                    </v-tooltip>
                                </td>
                                <td>
                                    {{ item.id }}
                                </td>
                                <td>
                                    {{ item.machine.name }}
                                </td>
                                <td>
                                    {{ formatDate(item.createdAt) }}
                                </td>
                                <td>
                                    {{ item.accidentStatus.name }}
                                </td>
                                <td>
                                    {{ item.accidentType.name }}
                                </td>
                                <td>
                                    {{ item.accidentDepartment.name }}
                                </td>
                                <td>
                                    <template v-if="item.creator.firstName && item.creator.lastName">
                                        {{ item.creator.firstName }} {{ item.creator.lastName }}
                                    </template>
                                    <template v-else>
                                        {{ item.creator.username }}
                                    </template>
                                </td>
                                <td>
                                    <template v-if="item.lastAssignee">
                                        <template v-if="item.lastAssignee.firstName && item.lastAssignee.lastName">
                                            {{ item.lastAssignee.firstName }} {{ item.lastAssignee.lastName }}
                                        </template>
                                        <template v-else>
                                            {{ item.lastAssignee.username }}
                                        </template>
                                    </template>
                                    <template v-else>
                                        -
                                    </template>
                                </td>
                                <td class="text-center">
                                    <v-icon v-if="item.adminAccepted" small color="success">
                                        mdi-check
                                    </v-icon>
                                    <v-icon v-else small color="error">
                                        mdi-close
                                    </v-icon>
                                </td>
                                <td>
                                    <div class="d-inline-flex">
                                        <v-tooltip v-if="isAdminUser" :open-delay="tooltipDelay" top>
                                            <template #activator="{on}">
                                                <v-btn
                                                    :disabled="item.adminAccepted || hasStatusDeleted(item.accidentStatusId)"
                                                    icon
                                                    :loading="actionLoading.acceptAccident[item.id]"
                                                    data-sentry-label="Zatwierdź awarię"
                                                    v-on="on"
                                                    @click="acceptAccident(item)"
                                                >
                                                    <v-icon v-if="!item.adminAccepted" color="green">
                                                        mdi-check-circle
                                                    </v-icon>
                                                    <v-icon v-else color="green">
                                                        mdi-check-circle-outline
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Zatwierdź</span>
                                        </v-tooltip>
                                        <v-tooltip :open-delay="tooltipDelay" max-width="500px" left>
                                            <template #activator="{on}">
                                                <v-icon
                                                    color="blue"
                                                    class="mx-1"
                                                    v-on="on"
                                                >
                                                    mdi-note-text-outline
                                                </v-icon>
                                            </template>
                                            <span>{{ item.description }}</span>
                                        </v-tooltip>
                                        <v-tooltip :open-delay="tooltipDelay" top>
                                            <template #activator="{on}">
                                                <v-btn
                                                    icon
                                                    data-sentry-label="Historia"
                                                    v-on="on"
                                                    @click="getAccidentStatusHistory(item.id)"
                                                >
                                                    <v-icon color="blue-grey">
                                                        mdi-history
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Historia</span>
                                        </v-tooltip>
                                        <v-tooltip :open-delay="tooltipDelay" top>
                                            <template #activator="{on}">
                                                <v-btn
                                                    icon
                                                    data-sentry-label="Edytuj"
                                                    v-on="on"
                                                    @click="editAccident(item.id)"
                                                >
                                                    <v-icon color="teal">
                                                        mdi-pencil
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Edytuj</span>
                                        </v-tooltip>
                                        <v-tooltip :open-delay="tooltipDelay" top>
                                            <template #activator="{on}">
                                                <v-btn
                                                    icon
                                                    :disabled="!deletableAccident(item)"
                                                    data-sentry-label="Usuń"
                                                    v-on="on"
                                                    @click="showConfirmDeleteAccidentDialog(item)"
                                                >
                                                    <v-icon color="pink">
                                                        mdi-delete
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Usuń</span>
                                        </v-tooltip>
                                    </div>
                                </td>
                            </tr>
                        </template>
                        <template slot="no-results" :value="true">
                            <p class="text-center">
                                Brak danych
                            </p>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import router from '@/router'
import store from '@/store'
import PageTitle from '@/components/common/PageTitle'
import ConfirmDialog from '@/components/common/ConfirmDialog'
import CreateAccidentDialog from './CreateAccidentDialog'
import StatusHistoryDialog from './StatusHistoryDialog'
import { errorHandler, addSentryBreadcrumb } from '@/utils/errorHandler'
import filters from '@/mixins/dataTableFilters'
import pagination from '@/mixins/dataTablePagination'
import tooltipDelay from '@/mixins/tooltip'
import dateFormatter from '@/mixins/dateFormatter'
import customFilters from '@/mixins/customFilters'
import dataTableClassSetter from '@/mixins/dataTableClassSetter'
import { hasUserPermission } from '@/utils/permissionsHandler'

let searchTimer

export default {
    name: 'AccidentsList',
    components: {
        PageTitle,
        ConfirmDialog,
        CreateAccidentDialog,
        StatusHistoryDialog
    },
    mixins: [
        dateFormatter,
        tooltipDelay,
        filters,
        pagination,
        dataTableClassSetter,
        customFilters
    ],
    beforeRouteEnter(to, from, next) {
        const userId = store.state.user.userId,
            query = `?accidentUser_id=${userId}`

        Promise.all([
            store.dispatch('maintenance/getAccidentTypes'),
            store.dispatch('maintenance/getMachines', { query }),
            store.dispatch('maintenance/getAccidentStatuses'),
            store.dispatch('maintenance/getAccidentUserDepartments'),
            store.dispatch('maintenance/getAccidentDepartments'),
            store.dispatch('administration/getUser', userId),
            store.dispatch('complaints/getProductionDepartments'),
            store.dispatch('administration/getCostCenterNumbers'),
        ])
            .then(responses => {
                next(vm => {
                    vm.userProductionSubDepartmentId = responses[5].data.profile.productionSubDepartmentId
                    vm.canUpdateAccidentDepartmentsFields = responses[5].data.profile.accidentDepartmentsIds.some(item =>
                        item === 1 || item === 2 || item === 3)
                    vm.canGenerateAccidentsReport = responses[5].data.profile.accidentDepartmentsIds.some(item =>
                        item === 1 || item === 2 || item === 3)
                })
            })
            .catch(error => {
                next(error)
                errorHandler(error)
            })
    },
    beforeRouteLeave(to, from, next) {
        if (!this.filtersCleared) {
            this.$store.dispatch('maintenance/clearAccidentsFilters')
            this.clearSelectedListItemId()
        }
        this.resetFiltersCleared()
        next()
    },
    data() {
        return {
            filtersMenu: false,
            menuFrom: false,
            menuTo: false,
            menuFromSolvedAtGte: false,
            menuFromSolvedAtLte: false,
            accident: {},
            accidentStatusHistory: [],
            createAccidentDialog: false,
            statusHistoryDialog: false,
            confirmAssignUserDialog: false,
            confirmDeleteAccidentDialog: false,
            actionLoading: {
                assignUser: false,
                deleteAccident: false,
                acceptAccident: {}
            },
            userProductionSubDepartmentId: null,
            hasFilters: false,
            searchCostCenterNumber: null,
            searchType: null,
            usersSearch: null,
            usersSearchLoading: false,
            users: [],
            generateAccidentsReportLoading: false,
            canUpdateAccidentDepartmentsFields: false,
            canGenerateAccidentsReport: false,
            accidentHeaders: [
                {
                    value: 'assign',
                    sortable: false,
                },
                {
                    text: 'ID',
                    value: 'id',
                    sortable: false,
                    width: 100
                },
                {
                    text: 'Maszyna',
                    value: 'machine',
                    sortable: false,
                },
                {
                    text: 'Data utworzenia',
                    value: 'createdAt',
                    sortable: false,
                },
                {
                    text: 'Status',
                    value: 'status',
                    sortable: false,
                },
                {
                    text: 'Typ',
                    value: 'type',
                    sortable: false,
                },
                {
                    text: 'Dział',
                    value: 'department',
                    sortable: false,

                },
                {
                    text: 'Zgłaszający',
                    value: 'creator',
                    width: 180,
                    sortable: false,
                },
                {
                    text: 'Prowadzący',
                    value: 'lastAssignee',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: 'Czy zatwierdzona',
                    value: 'adminAccepted',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    align: 'center',
                    sortable: false,
                    width: 100
                }
            ],
        }
    },
    computed: {
        isAdminUser() {
            return hasUserPermission('accidents_admin')
        },
        canDeleteAccident() {
            return hasUserPermission('accidents_admin_delete')
        },
        userName() {
            return this.$store.state.user.userName
        },
        userId() {
            return this.$store.state.user.userId
        },
        accidentsLoading() {
            return this.$store.state.maintenance.accidents.accidentsLoading
        },
        accidents() {
            return this.$store.state.maintenance.accidents.accidents
        },
        accidentStatuses() {
            return this.$store.state.maintenance.accidents.accidentStatuses
        },
        machines() {
            return this.$store.state.maintenance.accidents.machines
        },
        productionDepartments() {
            return this.$store.state.complaints.complaints.productionDepartments
        },
        accidentTypes() {
            return this.$store.state.maintenance.accidents.accidentTypes
        },
        accidentUserDepartments() {
            return this.$store.state.maintenance.accidents.accidentUserDepartments
        },
        costCenterNumbers() {
            return this.$store.state.administration.costCenterNumbers.costCenterNumbers
        },
        savedFilters() {
            return this.$store.state.maintenance.accidents.filters
        },
        selectedAccidentId() {
            return this.$store.state.common.selectedListItemId
        },
        userEmail() {
            return this.$store.state.user.userEmail
        },
        filterQuery() {
            const filters = Object.assign({}, this.filters)
            let query = ''

            for (let item in filters) {
                if (filters[item] != null && filters[item] != '') {
                    if (item == 'createdAt__gte') {
                        filters[item] += 'T00:00:00Z'
                    }
                    if (item == 'createdAt__lte') {
                        filters[item] += 'T23:59:59Z'
                    }
                    if (item == 'solvedAt__gte') {
                        filters[item] += 'T00:00:00Z'
                    }
                    if (item == 'solvedAt__lte') {
                        filters[item] += 'T23:59:59Z'
                    }
                    if (item === 'lastAssignee') {
                        filters[item] = this.userId
                    }
                    if (item === 'isSolved' && filters[item] === true) {
                        filters[item] = false
                    }
                    if (item === 'adminAccepted' && filters[item] === true) {
                        filters[item] = false
                    }
                    query = query.concat('&', `${item}=${filters[item]}`)
                }
                if (item === 'isSolved' && filters[item] === '') {
                    filters[item] = false
                    query = query.concat('&', `${item}=${filters[item]}`)
                }
            }

            return query
        },
    },
    watch: {
        usersSearch(value = null) {
            if (value === null) return

            this.usersSearchLoading = true

            clearTimeout(searchTimer)

            searchTimer = setTimeout(() => {
                if (value) {
                    this.searchUsers(value)
                } else {
                    this.usersSearchLoading = false
                    this.users = []
                }
            }, 500)
        },
    },
    mounted() {
        this.getAccidents()
    },
    created() {
        this.checkFilters()
    },
    methods: {
        searchUsers(query = '') {
            addSentryBreadcrumb('ui.action', 'Wyszukiwanie użytkownika')

            this.$store.dispatch('administration/findUsers', {
                paginate: '?limit=20',
                query: query
            })
                .then(response => {
                    this.users = response.data.results
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.usersSearchLoading = false
                })
        },
        toggleFiltersMenu() {
            this.filtersMenu = !this.filtersMenu
        },
        deletableAccident(accident) {
            return this.canDeleteAccident && !accident.adminAccepted
        },
        getAccidents() {
            this.$store.dispatch('maintenance/getAccidents', {
                paginate: this.paginate(),
                query: this.filterQuery
            })
                .then(response => {
                    this.handlePaginationResponse(response)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        getAccidentStatusHistory(id) {
            this.$store.dispatch('maintenance/getAccidentStatusHistory', id)
                .then(response => {
                    this.accidentStatusHistory = response.data.results
                    this.statusHistoryDialog = true
                }).catch(error => {
                    errorHandler(error)
                })
        },
        showCreateAccidentDialog() {
            this.$store.dispatch('administration/getCostCenterNumbers')
                .then(() => {
                    this.createAccidentDialog = true
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        closeCreateAccidentDialog() {
            this.createAccidentDialog = false

            setTimeout(() => {
                this.accident = {}
            }, 500)
        },
        closeStatusHistoryDialog() {
            this.statusHistoryDialog = false
        },
        createAccident() {
            this.accident.username = this.userName
            this.$store.dispatch('maintenance/createAccident', this.accident)
                .then(() => {
                    this.getAccidents()
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.closeCreateAccidentDialog()
                })
        },
        editAccident(accidentId) {
            this.savePagination(this.$options.name)
            this.saveFiltersCleared()
            this.setSelectedListItemId(accidentId)
            router.push({ name: 'maintenanceAccidentsEdit', params: { id: accidentId } })
                .catch(error => {
                    errorHandler(error)
                })
        },
        acceptAccident(accident) {
            this.actionLoading.acceptAccident[accident.id] = true
            let payload = Object.assign({}, accident)

            payload.adminAccepted = true
            this.$store.dispatch('maintenance/updateAccident', {...payload})
                .then(() => {
                    this.$store.dispatch('showNotification', {
                        type: 'success',
                        message: 'Awaria została zatwierdzona.'
                    })
                    accident.adminAccepted = true
                    this.actionLoading.acceptAccident[accident.id] = false
                    this.getAccidents()
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        deleteAccident(accident) {
            this.actionLoading.deleteAccident = true
            this.$store.dispatch('maintenance/deleteAccident', accident.id)
                .then(() => {
                    this.getAccidents()
                })
                .catch(error => errorHandler(error))
                .finally(() => {
                    this.actionLoading.deleteAccident = false
                    this.closeConfirmDeleteAccidentDialog()
                })
        },
        showConfirmAssignUserDialog(accident) {
            this.accident = accident
            this.confirmAssignUserDialog = true
        },
        closeConfirmAssignUserDialog() {
            this.confirmAssignUserDialog = false

            setTimeout(() => {
                this.accident = {}
            }, 500)
        },
        assignCurrentUser(accident) {
            this.actionLoading.assignUser = true

            const payload = {
                id: accident.id,
                accidentDepartmentId: accident.accidentDepartmentId,
                accidentTypeId: accident.accidentTypeId,
                accidentStatusId: 10, // assigned
                accidentStatusHistory: accident.accidentStatusHistory,
                description: accident.description,
                machineId: accident.machineId,
                username: this.userName,
                adminAccepted: accident.adminAccepted
            }

            this.$store.dispatch('maintenance/updateAccident', payload)
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.assignUser = false
                    this.closeConfirmAssignUserDialog()
                })
        },
        hasStatusDeleted(value) {
            return value === 100
        },
        accidentLabelClass(value) {
            switch (value) {
                case 1:
                    return 'v-data-table__label v-data-table__label--danger'
                case 40:
                case 50:
                case 60:
                    return 'v-data-table__label v-data-table__label--warning'
                default:
                    break
            }
        },
        isLoggedUserAssigned(lastAssignee) {
            if (lastAssignee) {
                return lastAssignee.id === this.userId
            }
        },
        checkFilters() {
            let { isSolved, lastAssignee, ...filters } = this.filters

            this.hasFilters = !Object.values(filters).every(item => item == null)
        },
        changeFilter() {
            this.$store.dispatch('maintenance/setAccidentsFilters', this.filters)
            this.checkFilters()
            this.resetPagination()
            this.getAccidents()
        },
        updatePagination(pagination) {
            this.pagination = pagination
            this.evaluateSavedPagination(this.$options.name)
            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending) {
                this.getAccidents()
            }
            this.clearPaginationPending()
        },
        showConfirmDeleteAccidentDialog(item) {
            this.confirmDeleteAccidentDialog = true
            this.accident = item
        },
        closeConfirmDeleteAccidentDialog() {
            this.confirmDeleteAccidentDialog = false
            this.accident = {}

            setTimeout(() => {
                this.accident = {}
            }, 500)
        },
        generateAccidentsReport() {
            this.generateAccidentsReportLoading = true
            this.$store.dispatch('maintenance/generateAccidentsReport', {
                query: this.filterQuery,
                userEmail: this.userEmail
            })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.generateAccidentsReportLoading = false
                })
        },
    }
}
</script>